<script>
export default {
  name: 'SelectField',
  props: {
    options: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      required: true
    }
  },
  methods: {
    isSelected (item) {
      return this.modelValue === item.value;

    }
  }
}
</script>

<template>
  <div>
      <label
          :for="label"
          class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
      >
        {{ label }}
      </label>
      <select
          :id="label"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          @input="$emit('update:modelValue', $event.target.value)"
      >
        <option selected value="" >Toutes</option>
        <option v-for="(option, index) in options" :key="index" :selected="isSelected(option)" :value="option.value">{{ option.text }}</option>
      </select>
  </div>
</template>

<style scoped>

</style>